import { ChevronRight, Check } from "lucide-react";

interface Props {
  currentIndex: number;
  steps: {
    title: string | null;
    description: string | null;
  }[];
}

export const OnboardingProgress = ({ currentIndex, steps }: Props) => {
  return (
    <div className="flex flex-wrap items-center justify-center gap-y-4">
      {steps.map((step, index) => {
        const isComplete = currentIndex > index;
        const isActive = currentIndex === index;

        return step.title ? (
          <div key={index} className="flex items-center">
            <div className="flex h-28 w-52 flex-col items-center space-y-2">
              <div
                className={`flex size-10 shrink-0 items-center justify-center rounded-full ${
                  isComplete
                    ? "bg-success text-primary-foreground"
                    : isActive
                      ? "bg-info text-primary-foreground"
                      : "bg-muted text-muted-foreground"
                }`}
              >
                {isComplete ? <Check className="size-5" /> : index + 1}
              </div>
              <div className="min-w-52 text-center text-sm">
                <div className="font-medium">{step.title}</div>
                <div className="text-muted-foreground text-xs">
                  {step.description}
                </div>
              </div>
            </div>
            {steps[index + 1]?.title && (
              <ChevronRight className="text-muted-foreground size-5" />
            )}
          </div>
        ) : null;
      })}
    </div>
  );
};
